// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.circularity .card-body {
    position: relative;
}

.header-title {
    width: 100%;
    float: left;
    font-weight: bold;
    color: #3894ad;
}

.recovery-potential {
    position: absolute;
    top: 30px;
    left: 40px;
}

.linear-outflow-in {
    position: absolute;
    bottom: 50px;
    left: 40px;
}

.circular-outflow {
    position: absolute;
    top: 30px;
    right: 40px;
    text-align: right;
}

.linear-outflow-out {
    position: absolute;
    bottom: 50px;
    right: 40px;
    text-align: right;
}

.lost-potential {
    position: absolute;
    top: 50%;
    left: 41%;
    text-align: right;
}

.recovery-potential > p,
.linear-outflow-in > p,
.circular-outflow > p,
.linear-outflow-out > p,
.lost-potential > p {
    margin-bottom: 0px;
    font-size: 1.35rem;
    font-weight: bold;
    color: #3894ad;
}

.lost-potential > p span{
    font-size: 1rem;
    font-weight: bold;
    color: #3894ad !important;
}

.recovery-potential > span,
.linear-outflow-in > span,
.circular-outflow > span,
.linear-outflow-out > span,
.lost-potential > span {
    font-size: 0.8rem;
    color: #3894ad !important;
    display: block;
}

.actual-recovery-1,
.actual-recovery-2{
    color: #3894ad !important;
    position: absolute;
    top: 30px;
    left: 51%;
    font-weight: bold;
}

.actual-recovery-2{
    top: calc(10px + 15.84%);
}`, "",{"version":3,"sources":["webpack://./src/pages/Circularity/CircularityPage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,iBAAiB;AACrB;;AAEA;;;;;IAKI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;;;;;IAKI,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B","sourcesContent":[".circularity .card-body {\n    position: relative;\n}\n\n.header-title {\n    width: 100%;\n    float: left;\n    font-weight: bold;\n    color: #3894ad;\n}\n\n.recovery-potential {\n    position: absolute;\n    top: 30px;\n    left: 40px;\n}\n\n.linear-outflow-in {\n    position: absolute;\n    bottom: 50px;\n    left: 40px;\n}\n\n.circular-outflow {\n    position: absolute;\n    top: 30px;\n    right: 40px;\n    text-align: right;\n}\n\n.linear-outflow-out {\n    position: absolute;\n    bottom: 50px;\n    right: 40px;\n    text-align: right;\n}\n\n.lost-potential {\n    position: absolute;\n    top: 50%;\n    left: 41%;\n    text-align: right;\n}\n\n.recovery-potential > p,\n.linear-outflow-in > p,\n.circular-outflow > p,\n.linear-outflow-out > p,\n.lost-potential > p {\n    margin-bottom: 0px;\n    font-size: 1.35rem;\n    font-weight: bold;\n    color: #3894ad;\n}\n\n.lost-potential > p span{\n    font-size: 1rem;\n    font-weight: bold;\n    color: #3894ad !important;\n}\n\n.recovery-potential > span,\n.linear-outflow-in > span,\n.circular-outflow > span,\n.linear-outflow-out > span,\n.lost-potential > span {\n    font-size: 0.8rem;\n    color: #3894ad !important;\n    display: block;\n}\n\n.actual-recovery-1,\n.actual-recovery-2{\n    color: #3894ad !important;\n    position: absolute;\n    top: 30px;\n    left: 51%;\n    font-weight: bold;\n}\n\n.actual-recovery-2{\n    top: calc(10px + 15.84%);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
